import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!

  return (_openBlock(), _createBlock(_component_zeile, null, {
    default: _withCtx(() => [
      _createVNode(_component_titel_zelle, null, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createElementVNode("strong", null, "Gebäudetyp", -1)
        ])),
        _: 1,
        __: [4]
      }),
      _createVNode(_component_zelle, { class: "iconRadioGebaeudetyp" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("input", {
            id: "einfamilienhaus",
            name: "gebaeudesubtyp",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.gebaeudesubtyp) = $event)),
            type: "radio",
            value: "efh",
            required: "",
            "data-fehlermeldung": "Bitte treffen Sie eine Auswahl.",
            "data-cy": "gebaeudetypEinfamilie",
            tabindex: "0",
            autofocus: "",
            class: "no-outline",
            "aria-required": "true",
            "aria-label": "Einfamilienhaus"
          }, null, 512), [
            [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.gebaeudesubtyp]
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("label", {
            for: "einfamilienhaus",
            class: "radiolabelGebaeudetyp"
          }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            id: "doppelhaushaelfte",
            name: "gebaeudesubtyp",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.gebaeudesubtyp) = $event)),
            type: "radio",
            value: "dhh",
            "data-cy": "doppelhaushaelfte",
            class: "no-outline",
            "aria-label": "Doppelhaushälfte"
          }, null, 512), [
            [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.gebaeudesubtyp]
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("label", {
            for: "doppelhaushaelfte",
            class: "radiolabelGebaeudetyp"
          }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            id: "reihenhaus",
            name: "gebaeudesubtyp",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.gebaeudesubtyp) = $event)),
            type: "radio",
            value: "rh",
            "data-cy": "reihenhaus",
            class: "no-outline",
            "aria-label": "Reihenhaus"
          }, null, 512), [
            [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.gebaeudesubtyp]
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("label", {
            for: "reihenhaus",
            class: "radiolabelGebaeudetyp"
          }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            id: "mehrfamilienhaus",
            name: "gebaeudesubtyp",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.gebaeudesubtyp) = $event)),
            type: "radio",
            value: "mfh",
            "data-cy": "mehrfamilienhaus",
            class: "no-outline",
            "aria-label": "Mehrfamilienhaus"
          }, null, 512), [
            [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.gebaeudesubtyp]
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("label", {
            for: "mehrfamilienhaus",
            class: "radiolabelGebaeudetyp"
          }, null, -1)),
          _createVNode(_component_validierungs_fehler, {
            "fehler-text": _ctx.fehler.gebaeudesubtyp,
            "reduzierter-abstand": true
          }, null, 8, ["fehler-text"])
        ]),
        _: 1,
        __: [5,6,7,8]
      })
    ]),
    _: 1
  }))
}